import React from 'react';
import styles from './CommunitySection.module.scss';
import LogosSection from '../LogosSection/LogosSection';
import iman from '../../../assets/landingpage/iman.png';
import imanMobile from '../../../assets/landingpage/iman-mobile.png';

const CommunitySection = () => {
  return (
    <section className={styles.community}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              Backed by content marketing expertise and celebrated by the
              community
            </h2>
            <p className={styles.description}>
              We've been featured in top media outlets, spoken on global stages
              on AI and content, advised leading industry teams and helped
              thousands of businesses transform their content approach with
              AI-powered systems... and now we're making these same strategies
              accessible to you through Vocable.
            </p>
          </div>
        </div>

        <div className={styles.imageContainer}>
          <img
            src={iman}
            alt="Iman Oubou at conference"
            className={styles.mainImage}
          />
          <img
            src={imanMobile}
            alt="Iman Oubou at conference"
            className={styles.mobileImage}
          />
        </div>
        <LogosSection />

      </div>
    </section>
  );
};

export default CommunitySection;
